import { render, staticRenderFns } from "./VesselParticularsProject.vue?vue&type=template&id=467776cd&scoped=true&"
import script from "./VesselParticularsProject.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsProject.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticularsProject.vue?vue&type=style&index=0&id=467776cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467776cd",
  null
  
)

export default component.exports